export default async function() {
    const short = document.querySelector('.slider-calc').getAttribute('data-short').toUpperCase()
    const coinDataJSON = await fetch(`/api/get-coins-data?assets=${short}`)
    const coinData = await coinDataJSON.json()

    console.table({
        short,
        coinDataJSON,
        coinData
    })
    console.log(coinData[short])
    return coinData[short]
}